export const DEPARTMENT_PS = 'PS';
export const DEPARTMENT_CS = 'CS';
export const DEPARTMENT_FN = 'FN';
export const DEPARTMENT_MKT = 'MKT';
export const DEPARTMENT_CEO = 'CEO';

export const ROLE_PSL = 'PSL';
export const ROLE_PSM = 'PSM';
export const ROLE_PSE = 'PSE';

export const ROLE_CSL = 'CSL';
export const ROLE_CSM = 'CSM';
export const ROLE_CSE = 'CSE';

export const ROLE_FL = 'FL';
export const ROLE_AM = 'AM';
export const ROLE_AE = 'AE';

export const ROLE_ML = 'ML';
export const ROLE_MM = 'MM';

export const DEPARTMENTS = [
  {
    value: DEPARTMENT_PS,
    label: 'Bộ phận quản lý đối tác (PS)',
    roles: [
      { value: ROLE_PSL, label: 'Partner Service Leader (PSL)' },
      { value: ROLE_PSM, label: 'Partner Service Manager (PSM)' },
      { value: ROLE_PSE, label: 'Partner Service Executive (PSE)' },
    ],
  },
  {
    value: DEPARTMENT_CS,
    label: 'Bộ phận quản lý khách hàng (CS)',
    roles: [
      { value: ROLE_CSL, label: 'Customer Service Leader (CSL)' },
      { value: ROLE_CSM, label: 'Customer Service Manager (CSM)' },
      { value: ROLE_CSE, label: 'Customer Service Executive (CSE)' },
    ],
  },
  {
    value: DEPARTMENT_FN,
    label: 'Bộ phận tài chính (FN)',
    roles: [
      { value: ROLE_FL, label: 'Finance Leader (FL)' },
      { value: ROLE_AM, label: 'Accounting Manager (AM)' },
      { value: ROLE_AE, label: 'Accounting Executive (AE)' },
    ],

  },
  {
    value: DEPARTMENT_MKT,
    label: 'Bộ phận marketing (MKT)',
    roles: [
      { value: ROLE_ML, label: 'Marketing Leader (ML)' },
      { value: ROLE_MM, label: 'Marketing Manager (MM)' },
    ],
  },
];

export const getExtranetFeatures = (role) => {
  if (!role) return '';
  const features = [];
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, ROLE_CSL, ROLE_CSM, ROLE_CSE, DEPARTMENT_PS, DEPARTMENT_CS].includes(role)) features.push('Trang chủ');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, DEPARTMENT_PS].includes(role)) features.push('Giá phòng');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, DEPARTMENT_PS].includes(role)) features.push('Khuyến mãi');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, ROLE_CSL, ROLE_CSM, ROLE_CSE, DEPARTMENT_PS, DEPARTMENT_CS].includes(role)) features.push('Chỗ nghỉ');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, ROLE_CSL, ROLE_CSM, ROLE_CSE, DEPARTMENT_PS, DEPARTMENT_CS].includes(role)) features.push('Đặt phòng');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, ROLE_CSL, ROLE_CSM, ROLE_CSE, DEPARTMENT_PS, DEPARTMENT_CS].includes(role)) features.push('Hộp thư');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, ROLE_FL, ROLE_AM, ROLE_AE, DEPARTMENT_PS, DEPARTMENT_FN].includes(role)) features.push('Tài chính');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, ROLE_CSL, ROLE_CSM, ROLE_CSE, DEPARTMENT_PS, DEPARTMENT_CS].includes(role)) features.push('Đánh giá');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, DEPARTMENT_PS].includes(role)) features.push('Phân tích');
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, DEPARTMENT_PS].includes(role)) features.push('Tài khoản');
  return features.length ? features.join(', ') : 'Không có quyền truy cập';
};

export const getIntranetFeatures = (role) => {
  if (!role) return '';
  const features = [];
  if ([ROLE_PSL, ROLE_PSM, ROLE_PSE, ROLE_ML, ROLE_MM, DEPARTMENT_PS, DEPARTMENT_MKT].includes(role)) features.push('Quản lý chỗ nghỉ');
  if ([DEPARTMENT_CEO].includes(role)) features.push('Quản lý tài khoản nội bộ');
  if ([ROLE_PSL, ROLE_PSM, DEPARTMENT_PS].includes(role)) features.push('Quản lý tài khoản đối tác');
  if ([ROLE_CSL, ROLE_CSM, DEPARTMENT_CS].includes(role)) features.push('Quản lý tài khoản khách hàng');
  if ([ROLE_CSL, ROLE_CSM, ROLE_CSE, DEPARTMENT_CS].includes(role)) features.push('Quản lý đặt phòng');
  if ([ROLE_CSL, ROLE_CSM, ROLE_ML, ROLE_MM, DEPARTMENT_CS, DEPARTMENT_MKT].includes(role)) features.push('Quản lý khách hàng');
  if ([ROLE_PSL, ROLE_CSL, ROLE_ML, ROLE_MM, DEPARTMENT_PS, DEPARTMENT_CS, DEPARTMENT_MKT].includes(role)) features.push('Quản lý đánh giá');
  if ([ROLE_PSL, ROLE_PSM, DEPARTMENT_PS].includes(role)) features.push('Quản lý doanh thu');
  if ([ROLE_PSL, ROLE_PSM, DEPARTMENT_PS].includes(role)) features.push('Quản lý thứ hạng');
  if ([DEPARTMENT_CEO, ROLE_FL, ROLE_AM, DEPARTMENT_FN].includes(role)) features.push('Quản lý tài chính');
  return features.length ? features.join(', ') : 'Không có quyền truy cập';
};
